// Espelho no navegador da validacao do servidor (backend/Services/EmailValidacao.cs).
//
// Existe porque o servidor recusar sozinho nao basta: a pessoa so descobre o erro DEPOIS de enviar, e
// no caso real que originou isto (27/08/2026) nem chegou a ver — o cadastro passou, o e-mail estava
// "@empresa.com.b" e o codigo de confirmacao bateu em bounce. Aqui o aviso aparece ao sair do campo,
// com a correcao pronta pra clicar.
//
// MANTENHA OS DOIS LADOS IGUAIS: se mexer aqui, mexa no EmailValidacao.cs (e vice-versa).

const FORMATO = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,24}$/i;

const DOMINIOS_ERRADOS = {
  "gmail.con": "gmail.com", "gmail.co": "gmail.com", "gmail.cm": "gmail.com",
  "gmail.om": "gmail.com", "gmail.comm": "gmail.com", "gmial.com": "gmail.com",
  "gmai.com": "gmail.com", "gamil.com": "gmail.com", "gmail.com.br": "gmail.com",
  "hotmail.con": "hotmail.com", "hotmail.co": "hotmail.com", "hotmail.cm": "hotmail.com",
  "hotmial.com": "hotmail.com", "hormail.com": "hotmail.com", "hotmil.com": "hotmail.com",
  "hotmaill.com": "hotmail.com", "hotmail.comm": "hotmail.com",
  "outlook.con": "outlook.com", "outlok.com": "outlook.com", "outllok.com": "outlook.com",
  "outlook.co": "outlook.com", "outook.com": "outlook.com",
  "yahoo.con": "yahoo.com", "yaho.com": "yahoo.com", "yahoo.co": "yahoo.com",
  "icloud.con": "icloud.com", "iclould.com": "icloud.com",
  "bol.com": "bol.com.br", "uol.com": "uol.com.br", "terra.com": "terra.com.br",
};

/** Sugestao de correcao, ou null quando nao da pra adivinhar com seguranca. */
export function sugerirEmail(valor) {
  const e = (valor || "").trim().toLowerCase();
  const at = e.lastIndexOf("@");
  if (at <= 0 || at === e.length - 1) return null;
  const usuario = e.slice(0, at);
  const dominio = e.slice(at + 1).replace(/^\.+|\.+$/g, "");
  if (!dominio) return null;

  if (DOMINIOS_ERRADOS[dominio]) return `${usuario}@${DOMINIOS_ERRADOS[dominio]}`;

  // Truncamento do ".br": "empresa.com.b" (o caso real).
  let m = dominio.match(/^(.+)\.(com|org|net|gov|edu|adv|eng|ind)\.b$/);
  if (m) return `${usuario}@${m[1]}.${m[2]}.br`;

  // Dedo escorregou depois do br: "empresa.com.brr".
  m = dominio.match(/^(.+)\.(com|org|net)\.br[a-z]$/);
  if (m) return `${usuario}@${m[1]}.${m[2]}.br`;

  // TLD de uma letra so: quase sempre falta o resto, e o .br domina o publico do eaiRH.
  m = dominio.match(/^(.+)\.b$/);
  if (m && m[1].includes(".")) return `${usuario}@${dominio}r`;

  return null;
}

/**
 * Valida o e-mail digitado. Devolve { ok, erro, sugestao }.
 * Campo vazio conta como ok: quem decide se e obrigatorio e o formulario.
 */
export function validarEmail(valor) {
  const e = (valor || "").trim();
  if (!e) return { ok: true, erro: "", sugestao: null };
  if (e.length > 200) return { ok: false, erro: "E-mail muito longo (máx. 200 caracteres).", sugestao: null };

  const sugestao = sugerirEmail(e);
  const complemento = sugestao ? ` Você quis dizer ${sugestao}?` : "";

  if (!FORMATO.test(e))
    return { ok: false, erro: `Esse e-mail parece incompleto ou com erro de digitação.${complemento}`, sugestao };

  const dominio = e.slice(e.lastIndexOf("@") + 1).toLowerCase();
  if (DOMINIOS_ERRADOS[dominio])
    return { ok: false, erro: `Confira o domínio do e-mail.${complemento}`, sugestao };

  return { ok: true, erro: "", sugestao: null };
}
